import * as Yup from "yup";

export const dataModel = {
  sapStartDate: "",
  sapStatus: "",
  idOrderSap: "",
  sapQuantity: "",
};

export const validationDataModel = Yup.object().shape({
  sapStartDate: Yup.date().optional("forms.validations.required"),
  sapStatus: Yup.string().optional(""),
  idOrderSap: Yup.string().optional(""),
  sapQuantity: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
